var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconToolScribbleMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "icon-tool-scribble-medium",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-tool-scribble-medium1",
    serifid: "icon-tool-scribble-medium"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.19,19.149c0.466,-0.053 0.889,0.282 0.942,0.748c0.054,0.466 -0.281,0.889 -0.747,0.942c-0.869,0.1 -1.541,0.151 -2.138,0.16c-0.765,0.011 -1.412,-0.047 -2.189,-0.164c-1.535,-0.231 -3.507,-0.651 -4.684,-1.477c-0.839,-0.589 -1.327,-1.369 -1.289,-2.35c0.018,-0.47 0.183,-0.925 0.462,-1.352c0.298,-0.456 0.734,-0.883 1.207,-1.26c0.777,-0.618 2.805,-1.372 4.161,-2.864c0.61,-0.671 1.07,-1.512 1.13,-2.597c0.046,-0.822 -0.079,-1.561 -0.659,-2.196c-0.464,-0.509 -1.186,-0.946 -2.243,-1.343c-1.439,-0.54 -3.597,-1.064 -5.383,-0.393c-1.338,0.503 -2.4,1.727 -2.783,4.114c-0.097,0.608 -0.08,1.565 -0.272,2.449c-0.149,0.687 -0.422,1.329 -0.904,1.793c-0.629,0.606 -1.617,0.992 -3.239,0.699c-0.462,-0.083 -0.77,-0.525 -0.686,-0.988c0.083,-0.462 0.526,-0.769 0.988,-0.686c0.868,0.157 1.42,0.075 1.756,-0.25c0.376,-0.362 0.49,-0.918 0.55,-1.465c0.076,-0.681 0.054,-1.363 0.128,-1.821c0.513,-3.206 2.066,-4.762 3.863,-5.437c2.182,-0.82 4.823,-0.267 6.58,0.393c1.377,0.517 2.296,1.125 2.902,1.788c0.913,1 1.173,2.143 1.101,3.437c-0.084,1.521 -0.714,2.706 -1.57,3.647c-1.429,1.572 -3.542,2.4 -4.36,3.051c-0.327,0.26 -0.637,0.545 -0.843,0.86c-0.102,0.155 -0.179,0.315 -0.186,0.487c-0.021,0.554 0.454,0.876 1.017,1.156c1.012,0.503 2.398,0.756 3.509,0.923c0.679,0.102 1.244,0.154 1.912,0.145c0.55,-0.008 1.167,-0.057 1.967,-0.149Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolScribbleMedium);
export default __webpack_public_path__ + "static/media/icon-tool-scribble-medium.450587da84ccff3769825d0e7ddb845e.svg";
export { ForwardRef as ReactComponent };